import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useMemo, useRef } from 'react';
import { toEncodedClientDetails } from '@peloton/analytics/clientDetailsHeader';
import { startedSession } from '@engage/api-v2';
import { ok, pending, isOk, getOkValue } from '@engage/result';
import { useIsLoggedIn } from '@webtv/auth';
import { engageApi } from '@webtv/data-fetch/singletons';
import { PELOTON_PLATFORM } from '@webtv/env';
import { useBaseAnalyticsProperties } from './useBaseAnalyticsProperties';

var useClientDetails = function useClientDetails() {
  var _useBaseAnalyticsProp = useBaseAnalyticsProperties(),
      _useBaseAnalyticsProp2 = _slicedToArray(_useBaseAnalyticsProp, 2),
      baseProps = _useBaseAnalyticsProp2[0],
      propsArePending = _useBaseAnalyticsProp2[1];

  return useMemo(function () {
    return propsArePending ? pending : ok(toEncodedClientDetails(baseProps));
  }, [baseProps, propsArePending]);
};

var useStartSession = function useStartSession() {
  var hasStartedSession = useRef(false);

  var _useIsLoggedIn = useIsLoggedIn(),
      isLoggedIn = _useIsLoggedIn.isLoggedIn;

  var clientDetails = useClientDetails();
  useEffect(function () {
    if (!hasStartedSession.current && getOkValue(isLoggedIn) && isOk(clientDetails)) {
      hasStartedSession.current = true;
      startedSession(engageApi, PELOTON_PLATFORM, clientDetails.value);
    }
  }, [clientDetails, isLoggedIn]);
};

export default useStartSession;